import { IComponentOptions } from "angular";
import { ProgressivesDetailMachinesComponentController } from "./controller";

export const vsName = "progressivesDetailMachines";

export const progressivesDetailMachinesComponentOptions: IComponentOptions = {
  controller: ProgressivesDetailMachinesComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    progressiveDefinition: "<",
  },
};
